import React from 'react'
import { useDispatch } from 'react-redux'
import { reduxForm, Field } from 'redux-form'

import { updateAction } from '../../../ducks/actions'
import Card from '../../Shared/Card'
import WrappedInput from '../../Shared/Forms/WrappedInput'

const FORM_NAME = 'actionNameForm'

const validate = values => {
  const errors = {}

  if (!values.name) {
    errors.name = 'Name cannot be blank'
  }

  return errors
}

const Form = function Form() {
  return (
    <Card>
      <Field
        name="name"
        component={WrappedInput}
        label="Action Name"
        placeholder="My Action"
      />
    </Card>
  )
}

const WrappedForm = reduxForm({
  form: FORM_NAME,
  validate,
})(Form)

export default function ActionName({ action, setBlankName }) {
  const dispatch = useDispatch()

  const handleChange = ({ name }) => {
    if (!name) {
      // Do nothing
      setBlankName(true)

      return
    }

    setBlankName(false)

    dispatch(updateAction(action.id, { name }))
  }

  const { name } = action

  return <WrappedForm onChange={handleChange} initialValues={{ name }} />
}
